// jQuery(".article_lists .sidebar-filters ul li h4").click(function () {
//   jQuery(".article_lists .sidebar-filters ul > li").toggleClass("open");
// });

// jQuery('.nhr_filter_column .clear_filters').each(function () {
//   jQuery(this).parent().parent().addClass('open');
//   jQuery('.nhr_filter_column.open ul').addClass('showingall');
//   jQuery('#pe-left.nhr_filter_sidebar').addClass(' open');

// });


// do stuff

jQuery(function () {
  setTimeout(
    function () {
      jQuery('.sidebar-filters li h4, .sidebar-filters li ul li label').attr('tabindex', '0');
      jQuery('.sidebar-filters li.show_more, .sidebar-filters li.show_less').attr('tabindex', '0');
      jQuery('.sidebar-filters div.clear-dates').attr('tabindex', '0');
      jQuery('.sf-input-checkbox').attr('tabindex', '-1');
    }, 200);
});

function a11yClick(event) {
  if (event.type === 'click') {
    return true;
  } else if (event.type === 'keypress') {
    var code = event.charCode || event.keyCode;
    if ((code === 32) || (code === 13)) {
      return true;
    }
  } else {
    return false;
  }
}

jQuery('.sidebar-filters li ul li label, .sidebar-filters li.show_more, .sidebar-filters li.show_less').keypress(function (e) {
  if ((e.keyCode ? e.keyCode : e.which) == 13) {
    jQuery(this).trigger('click');
  }
});

function sidebarFilterToggle() {
  jQuery('.article_lists .sidebar-filters ul li h4').on('click keypress', function (event) {
    if (a11yClick(event) === true) {
      if (
        jQuery(this).parent().hasClass("open")
      ) {
        jQuery(this)
          .parent().removeClass("open");
      } else {
        jQuery(this).parent().addClass("open");
      }
    }
  });
}

jQuery(document).ajaxComplete(function () {
  sidebarFilterToggle();
});

jQuery(document).ready(function () {

  sidebarFilterToggle();

  jQuery('.video-captions label').on('click', function (event) {
    if (jQuery('.video-captions input#video-transcript').is(':checked')) {
      jQuery(this).attr('aria-expanded', 'false');
    } else {
      jQuery(this).attr('aria-expanded', 'true');
    }
  });

  jQuery('.video-captions label').on('keypress', function (event) {
    event.preventDefault();
    if (a11yClick(event) === true) {
      jQuery(this).click();
      jQuery(this).focus();
    }
  });

  // jQuery(".article_lists .sidebar-filters ul li ul").append(
  //   "<li class='show_more'>Show More</li><li class='show_less'>Show Less</li>"
  // );

  if (
    jQuery(".article_lists .sidebar-filters ul li ul li.show_more").length > 0
  ) {
    // Already exists
  } else {
    jQuery(".article_lists .sidebar-filters ul li ul").append(
      "<li class='show_more'>Show More</li><li class='show_less'>Show Less</li>"
    );
  }

  jQuery(".show_more").on('click keypress', function (event) {
    if (a11yClick(event) === true) {
      if (
        jQuery(this)
        .parent()
        .hasClass("show_full_list")
      ) {
        jQuery(this)
          .parent()
          .removeClass("show_full_list");
      } else {
        jQuery(this)
          .parent()
          .addClass("show_full_list");
      }
    }
  });

  jQuery(".show_less").on('click keypress', function (event) {
    if (a11yClick(event) === true) {
      if (
        jQuery(this)
        .parent()
        .hasClass("show_full_list")
      ) {
        jQuery(this)
          .parent()
          .removeClass("show_full_list");
      } else {
        jQuery(this)
          .parent()
          .addClass("show_full_list");
      }
    }
  });

  // if (window.location.href.indexOf("_sft_nihrcategory") > 0) {
  //   jQuery(
  //     ".article_lists .sidebar-filters ul li.sf-field-taxonomy-nihrcategory ul"
  //   ).addClass(" show_full_list");
  // }
  // if (window.location.href.indexOf("_sft_journalsource") > 0) {
  //   jQuery(
  //     ".article_lists .sidebar-filters ul li.sf-field-taxonomy-journalsource ul"
  //   ).addClass(" show_full_list");
  // }
});

jQuery("button.article-filter").click(function () {
  if (jQuery(this).hasClass("active")) {
    jQuery(".article_lists .sidebar-filters").removeClass("open");
    jQuery("body").removeClass("filter-open");
    jQuery(this).attr("aria-expanded", "false");
    jQuery(this).removeClass("active");
  } else {
    jQuery(".article_lists .sidebar-filters").addClass("open");
    jQuery("body").addClass("filter-open");
    jQuery(".searchandfilter .sf-field-search input.sf-input-text").focus();
    jQuery(this).attr("aria-expanded", "true");
    jQuery(this).addClass("active");
  }
});

jQuery(
  ".sidebar-filters .filter-close, .sidebar-filters button.apply-filters"
).click(function () {
  jQuery(".article_lists .sidebar-filters").removeClass("open");
  jQuery("body").removeClass("filter-open");
});

// jQuery(document).bind("ready ajaxComplete", function () {
//   if (window.location.href.indexOf("_sft_audiencetype") > 0) {
//     jQuery(
//       ".article_lists .sidebar-filters ul li.sf-field-taxonomy-audiencetype"
//     ).addClass(" open");
//   }
//   if (window.location.href.indexOf("_sft_mediatype") > 0) {
//     jQuery(
//       ".article_lists .sidebar-filters ul li.sf-field-taxonomy-mediatype"
//     ).addClass(" open");
//   }
//   if (window.location.href.indexOf("post_types") > 0) {
//     jQuery(".article_lists .sidebar-filters ul li.sf-field-post_type").addClass(
//       " open"
//     );
//   }
//   if (window.location.href.indexOf("_sft_nihrcategory") > 0) {
//     jQuery(
//       ".article_lists .sidebar-filters ul li.sf-field-taxonomy-nihrcategory"
//     ).addClass(" open");
//   }
//   if (window.location.href.indexOf("_sft_journalsource") > 0) {
//     jQuery(
//       ".article_lists .sidebar-filters ul li.sf-field-taxonomy-journalsource"
//     ).addClass(" open");
//   }
//   if (window.location.href.indexOf("post_date") > 0) {
//     jQuery(".article_lists .sidebar-filters ul li.sf-field-post_date").addClass(
//       " open"
//     );
//   }
// });

jQuery(document).bind("ready ajaxComplete", function () {
  if (jQuery(".filter-footer .clear-all-looped").length > 0) {
    // Already exists
  } else {
    jQuery(".clear-all-looped")
      .detach()
      .prependTo(".filter-footer");
  }

  // Tooltips
  if (
    !jQuery("li.sf-field-taxonomy-journalsource h4 span").hasClass(
      "filter-tooltip"
    )
  ) {
    jQuery("li.sf-field-taxonomy-journalsource h4").append(
      '<span class="filter-tooltip header">i<span class="tooltip-text">Filter Alerts by the peer reviewed journal where they were originally published</span></span>'
    );
  }
  if (!jQuery("li.sf-field-post_type ul li span").hasClass("filter-tooltip")) {
    jQuery("li.sf-field-post_type ul li:nth-of-type(1)").append(
      '<span class="filter-tooltip list">i<span class="tooltip-text">Short summaries of the latest health research</span></span>'
    );
    jQuery("li.sf-field-post_type ul li:nth-of-type(2)").append(
      '<span class="filter-tooltip list">i<span class="tooltip-text">Specially created reviews on recent research</span></span>'
    );
    jQuery("li.sf-field-post_type ul li:nth-of-type(3)").append(
      '<span class="filter-tooltip list">i<span class="tooltip-text">Overview of recent research on important topics</span></span>'
    );
  }

  // var url = window.location.href;
  // var protocol = window.location.protocol;
  // var hostname = window.location.hostname;
  // var path = window.location.pathname;
  // var path = window.location.pathname;
  // var sitename = protocol + "//" + hostname + path;

  // if (window.location.href.indexOf("?_sf_ppp=") > 0) {
  //   jQuery("a.ten").attr("href", sitename + "?_sf_ppp=10");
  //   jQuery("a.twenty").attr("href", sitename + "?_sf_ppp=20");
  //   jQuery("a.thirty").attr("href", sitename + "?_sf_ppp=30");
  // } else if (window.location.href.indexOf("?") > 0) {
  //   jQuery("a.ten").attr("href", url + "&_sf_ppp=10");
  //   jQuery("a.twenty").attr("href", url + "&_sf_ppp=20");
  //   jQuery("a.thirty").attr("href", url + "&_sf_ppp=30");
  // }

  var currentUrl = window.location.href;

  var urlTen = new URL(currentUrl);
  urlTen.searchParams.set("_sf_ppp", "10"); // setting your param
  var newUrlTen = urlTen.href;

  var urlTwenty = new URL(currentUrl);
  urlTwenty.searchParams.set("_sf_ppp", "20"); // setting your param
  var newUrlTwenty = urlTwenty.href;

  var urlThirty = new URL(currentUrl);
  urlThirty.searchParams.set("_sf_ppp", "30"); // setting your param
  var newUrlThirty = urlThirty.href;

  jQuery("a.ten").attr("href", newUrlTen);
  jQuery("a.twenty").attr("href", newUrlTwenty);
  jQuery("a.thirty").attr("href", newUrlThirty);

  jQuery("option.ten").attr("value", newUrlTen);
  jQuery("option.twenty").attr("value", newUrlTwenty);
  jQuery("option.thirty").attr("value", newUrlThirty);


  // var urlTitleAsc = new URL(currentUrl);
  // urlTitleAsc.searchParams.set("sort_order", "title asc"); // setting your param
  // var newurlTitleAsc = urlTitleAsc.href;
  // jQuery("option.title-asc").attr("value", newurlTitleAsc);

  // var urlTitleDesc = new URL(currentUrl);
  // urlTitleDesc.searchParams.set("sort_order", "title desc"); // setting your param
  // var newurlurlTitleDesc = urlTitleDesc.href;
  // jQuery("option.title-desc").attr("value", newurlurlTitleDesc);

  // var urlDateAsc = new URL(currentUrl);
  // urlDateAsc.searchParams.set("sort_order", "date asc"); // setting your param
  // var newurlDateAsc = urlDateAsc.href;
  // jQuery("option.date-asc").attr("value", newurlDateAsc);

  // var urlDateDesc = new URL(currentUrl);
  // urlDateDesc.searchParams.set("sort_order", "date desc"); // setting your param
  // var newurlDateDesc = urlDateDesc.href;
  // jQuery("option.date-desc").attr("value", newurlDateDesc);

  // var urlRelevenceAsc = new URL(currentUrl);
  // urlRelevenceAsc.searchParams.set("sort_order", "relevence asc"); // setting your param
  // var newurlRelevenceAsc = urlRelevenceAsc.href;
  // jQuery("option.relevence-asc").attr("value", newurlRelevenceAsc);

  // var urlRelevenceDesc = new URL(currentUrl);
  // urlRelevenceDesc.searchParams.set("sort_order", "relevence desc"); // setting your param
  // var newurlRelevenceDesc = urlRelevenceDesc.href;
  // jQuery("option.relevence-desc").attr("value", newurlRelevenceDesc);

});

jQuery(document).bind("ready ajaxComplete", function () {
  if (jQuery("ul.sf_date_field .clear-dates").length > 0) {
    // Already exists
  } else {
    jQuery(".clear-dates")
      .clone()
      .appendTo("ul.sf_date_field");
  }

  if (jQuery("input.sf-datepicker .clear-dates").length > 0) {
    // Already exists
  } else {
    jQuery(".clear-dates").on('click keypress', function (event) {
      if (a11yClick(event) === true) {
        jQuery("input.sf-datepicker")
          .val("")
          .submit();
      }
    });

  }

});

jQuery(document).bind("ready", function () {
  jQuery(".sidebar-filters .sf-field-sort_order").clone().prependTo("#sort-order ul");

  // var bothselects = jQuery("#sort-order .sf-input-select, .sidebar-filters .sf-field-sort_order .sf-input-select");
  // bothselects.change(function (e) {
  //   bothselects.val(this.value); // "this" is the changed one
  //   jQuery(".sidebar-filters .sf-field-submit input").trigger("click");
  //   // do whatever else you need to do
  //   console.log("changed");
  // });
});


// jQuery(document).bind("ready ajaxComplete", function () {
//   var bothselects = jQuery("#sort-order .sf-input-select, .sidebar-filters .sf-field-sort_order .sf-input-select");
//   bothselects.change(function (e) {
//     bothselects.val(this.value); // "this" is the changed one
//     jQuery(".sidebar-filters .sf-field-submit input").trigger("click");
//     // do whatever else you need to do
//     console.log("changed");
//   });
// });

jQuery(document).on('change', '#sort-order .sf-input-select', function (e) {
  var clonedSort = jQuery("#sort-order .sf-input-select");
  var originalSort = jQuery(".sidebar-filters .sf-field-sort_order .sf-input-select");
  console.log(clonedSort.val());
  originalSort.val(clonedSort.val());
    jQuery(".sidebar-filters .sf-field-submit input").trigger("click");

  console.log("fin");
});



// jQuery(document).ready(function(){
//   jQuery(".article_lists .sidebar-filters ul li h4, .show_more").trigger("click");
// });